import { render, staticRenderFns } from "./TemplateBasedList.vue?vue&type=template&id=288756e8&"
import script from "./TemplateBasedList.vue?vue&type=script&lang=ts&"
export * from "./TemplateBasedList.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateBasedList.vue?vue&type=style&index=0&id=288756e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports